import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';

interface ThemeContextType {
  isDarkMode: boolean;
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Always use light mode (dark mode toggle removed)
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    // Clear any old theme from localStorage and always set to light
    localStorage.setItem('theme', 'light');
  }, []);

  const toggleTheme = useCallback(() => {
    setIsDarkMode(prev => {
      console.log('Toggle: current =', prev, '→ new =', !prev);
      return !prev;
    });
  }, []); // No dependencies needed since we use prev =>

  const value = useMemo(() => ({ 
    isDarkMode, 
    toggleTheme 
  }), [isDarkMode, toggleTheme]);

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

